
$(function() {
    $( document ).ready(function() {
            $('.selectize').selectize({});

        	var options = {

        		url: function (phrase) {
        			return '/fr/suggest/'+phrase;
        		},
        		getValue: function (element) {
        			return element;
        		},
        		requestDelay: 500,
        		list: {
        			onClickEvent: function () {
        				$('.search form').get(0).submit();
        			},
        			match: {
        				enabled: true
        			}
        		},
        		theme: "square"
        	};

        	if (typeof $.fn.easyAutocomplete !== 'undefined') {
        		$('input[name="q"]').easyAutocomplete(options);
        	}

        	$('body').on('click', 'a[data-toggle="decrease"]', function (e) {
        		e.preventDefault();
        		var form = $(this).closest('form');
        		var input = $(this).siblings('input[name="quantity"]');

        		if (parseInt(input.val()) > 1) {
        			input.val(parseInt(input.val()) - 1);
        			input.trigger('change');
        		}

        	}).on('click', 'a[data-toggle="increase"]', function (e) {
        		e.preventDefault();

        		var form = $(this).closest('form');
        		var input = $(this).siblings('input[name="quantity"]');
        		var max = input.attr('max') === undefined ? null : parseInt(input.attr('max'));
        		var val = parseInt(input.val());

        		if (max === null || val < max) {
        			input.val(val + 1);
        			input.trigger('change');
        		}
        	}).on('click', '#btn-ticker', function (e) {
        		e.preventDefault();
        		$.ajax({
        			url: '/fr/banner/session/'+$('#btn-ticker').attr('data-id'),
        			type: 'get',
        			complete: function(response) {
        				$('#banner').remove();
        			}
        		});
        	});

        	$('.lazy').Lazy({
                afterLoad: function (element) {
                    $(element).parents().removeClass('spinner');
                },
                onError: function (element) {
                    $(element).parents().removeClass('spinner');
                }
            });
    });
});
